<div
  [class.entered]="hasValue()"
  [class.active]="active"
  class="flex w-full rounded-3 border border-transparent bg-grey-50 hover:bg-grey-100"
  data-testid="searchbar"
>
  <div class="flex w-[3rem] items-center justify-center">
    <fa-icon [icon]="searchIcon"></fa-icon>
  </div>
  <div class="flex w-full">
    <input
      #searchInput
      type="search"
      (focus)="onFocus($event)"
      (blur)="onBlur()"
      [formControl]="formControlInput()"
      class="w-full border-none bg-transparent! py-[0.5625rem] pr-md text-base placeholder-grey-500 outline-0 hover:placeholder-grey-600"
      [placeholder]="searchPlaceholder$ | async"
    />
    @if (loading$(); as loading$) {
      @if (loading$ | async) {
        <div class="flex items-center pr-4" data-testid="spinner">
          <cft-spinner></cft-spinner>
        </div>
      }
    }
    @if (hasValue()) {
      <button class="h-full" (click)="clearInput()" type="button">
        <fa-icon [icon]="closeIcon"></fa-icon>
      </button>
    }
  </div>
</div>
